import Http from "./http";

export const getMemberActionStatusesAPI = (payload = {}) => {
  return Http.post("admin/campaign/member-action-statuses", payload);
};
